import WithdrawDetail from "./styles";
export default WithdrawDetail;
